import {ProjectXZToXYTransformer} from './PointsTransformer';
import {Points} from './Points';

declare let THREE: any;

export class ObjectPoints {

  private readonly XY: Points;
  private readonly XZ: Points;

  constructor(object) {
    object.updateMatrixWorld();
    const entity = object.userData.entity;
    const size = new THREE.Vector3(entity.length, entity.height, entity.width);
    this.XY = new Points(object.matrixWorld, size);
    this.XZ = new Points(object.matrixWorld, size, ProjectXZToXYTransformer);
  }

  setPosition(position) {
    this.XY.setPosition(position);
    this.XZ.setPosition(position);
    return this;
  }

  setRotation(rotation) {
    this.XY.setRotation(rotation);
    this.XZ.setRotation(rotation);
    return this;
  }

  setBorder(border: number) {
    this.XY.setBorder(border);
    this.XZ.setBorder(border);
    return this;
  }

  pointsXY() {
    return this.XY.points;
  }

  pointsXZ() {
    return this.XZ.points;
  }

}




// WEBPACK FOOTER //
// ./src/app/services/collision/polygon/ObjectPoints.ts